import React from 'react';
import DataPersonal from './DataPersonal';
import DataMeasure from './DataMeasure';
import Filters from './Filters';

function MonitoringACI() {
	return (
		<>
			<Filters />
			<DataPersonal />
			<DataMeasure />
		</>
	);
}

export default MonitoringACI;
